/* Установщик «Фотосессия товара»: объект в window на том месте порядка скриптов, где стоял assets/bot-pshoot.js.
   В серверном режиме движок шаблона получает сервер экрана (pshoot-server.ts) и экран pshoot встаёт в реестр движков студии;
   выбирает его только список экранов сборки (engine-kit/engine-default.json — пустой до коммита переключения, инвариант I4). */
import { isServerMode } from '../../platform/server-mode';
import { createPshoot } from './engine';
import { createPshootServer, registerPshootEngine } from './pshoot-server';

export function installPshoot() {
  const server = isServerMode();
  createPshoot(server ? createPshootServer : null);
  if (server) registerPshootEngine();
}
